import { useEffect, useState } from "react";
import FileSaver from "file-saver";
import { toast } from "react-toastify";

import { nameCsvFile, reportUnexpectedError } from "@graffer-inc/smart-apply";

import apiClient from "../../../../../../application/apis/api-client";
import { CloudGovApiError } from "../../../../../../application/domain/api-error";
import { StaticFeatureFlags } from "../../../../../../feature-flags";

type Props = {
  orgId: string;
};

export const useServiceProviderPayment3DSecureAuthRawdataHooks = ({
  orgId,
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [terms, setTerms] = useState<string[]>([]);
  const [internalTerms, setInternalTerms] = useState<string[]>([]);
  const [targetYYYYMM, setTargetYYYYMM] = useState("");

  useEffect(() => {
    fetchTerms();
    //eslint-disable-next-line
  }, []);

  const fetchTerms = async () => {
    if (!StaticFeatureFlags.IS_SANDBOX) {
      try {
        const { data } =
          await apiClient.fetchPayment3DSecureAuthRawdataTermsOrgId(orgId);

        if (data.length > 0) {
          setTerms(data);
          setInternalTerms(data);
        }
      } catch (e) {
        if (!CloudGovApiError.is404(e)) {
          reportUnexpectedError(e);
        }
      }
    }
  };

  const onDownload = async (orgId: string, yyyymm: string) => {
    setIsLoading(true);

    try {
      const { data } =
        await apiClient.downloadPayment3DSecureAuthRawdataByOrgId(
          orgId,
          yyyymm,
        );
      FileSaver.saveAs(
        data,
        nameCsvFile(`3dsecure-auth-rawdata-${orgId}-${yyyymm}`),
      );
    } catch (e) {
      if (CloudGovApiError.is404(e)) {
        toast.error("データがありません。");
        return;
      }
      toast.error("CSVダウンロードに失敗しました。");
      reportUnexpectedError(e);
    } finally {
      setIsLoading(false);
    }
  };

  const onInternalDownload = async (orgId: string, yyyymm: string) => {
    setIsLoading(true);

    try {
      const { data } =
        await apiClient.downloadPayment3DSecureAuthInternalRawdataByOrgId(
          orgId,
          yyyymm,
        );
      FileSaver.saveAs(
        data,
        nameCsvFile(`3dsecure-auth-internal-rawdata-${orgId}-${yyyymm}`),
      );
    } catch (e) {
      if (CloudGovApiError.is404(e)) {
        toast.error("データがありません。");
        return;
      }
      toast.error("CSVダウンロードに失敗しました。");
      reportUnexpectedError(e);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    terms,
    internalTerms,
    targetYYYYMM,
    setTargetYYYYMM,
    onDownload,
    onInternalDownload,
  };
};
